import Vue from 'vue'
import Router from 'vue-router'

import HomeRoutes from './home'
import AboutRoutes from './about'
import PolicyRoutes from './policy'
import InfoRoutes from './info'
import BuypointRoutes from './buypoint'
//import RegisterRoutes from './register'
import LoginRoutes from './login'
// import AccountRoutes from './account'
// import BusinessesRoutes from './businesses'
// import SearchRoutes from './search'
//import SellpointRoutes from './sellpoint'
//import CreateSellpointRoutes from './create'
// import CartRoutes from './cart'
// import OrderRoutes from './order'
// import CheckoutRoutes from './checkout'
// import OrdersRoutes from './orders'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        HomeRoutes,
        AboutRoutes,
        PolicyRoutes,
        InfoRoutes,
        BuypointRoutes,
        // BusinessesRoutes,
        // SearchRoutes,
        // RegisterRoutes,
        LoginRoutes,
        // AccountRoutes,
        // CreateSellpointRoutes,
        // CartRoutes,
        // OrderRoutes,
        // CheckoutRoutes,
        // OrdersRoutes,
       // SellpointRoutes,
        {path: '*', redirect: '/'} // 404
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js